import DataTile from "./DataTile";
import React from "react";
import RiskRibbon from "../../risk/RiskRibbon";
import {useSelector} from "react-redux";
import {fetchTargets} from "../../../actions";
import {bbIsServiceHighRisk, filterObject} from "../../../util/bbHelpers";
import CustomActiveShapePieChart from "../charts/CustomActiveShapePieChart";

const Tile = (props) => {

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView} = useSelector(({customer}) => customer);

    const customerIdToUse = customerId ? customerId : customerInView;

    const colorFunction = (stateData) => {
        return "light";
    }

    // const getHighRiskServices = (servicesArray) => {
    //     return servicesArray.filter(service => bbIsServiceHighRisk(service)).length
    // }

    const showPieWith = (stateData) => {
        if (stateData && stateData[customerIdToUse]) {

            try {

                const {
                    [customerIdToUse] : {
                        active_services_dictionary,
                    }
                } = stateData

                const highRiskServices = filterObject(active_services_dictionary, (service, occurrances) => bbIsServiceHighRisk(service));
                // console.log("got the following highRiskServices", highRiskServices);
                //highRiskServices is an object, need to convert to array of objects
                const arrayOfHighRiskServicesData = []
                for (const [service, occurrances] of Object.entries(highRiskServices)) {
                    arrayOfHighRiskServicesData.push(
                        {
                            name: service,
                            value: occurrances
                        }
                    )
                }
                // console.log("got the following arrayOfHighRiskServicesData", arrayOfHighRiskServicesData);

                // if (arrayOfHighRiskServicesData.length > 0) {

                    return <div
                        className={"animated fadeIn animation-duration-7"}
                        style={{ marginTop: -40, marginBottom: -15 }}
                    ><CustomActiveShapePieChart
                        data = {arrayOfHighRiskServicesData}
                        riskBy5={translateValueToRisk(valueFunction(stateData))}
                    /></div>
                // } else {
                //     // return <BBIconArrowsInOut style={{fontSize: "70px"}}/>
                //    return   <div
                //        className={"animated fadeIn animation-duration-7"}
                //        style={{ marginTop: -40, marginBottom: -15 }}
                //    ><CustomActiveShapePieChart data = {[
                //        { name: 'Group A', value: 400 },
                //        { name: 'Group B', value: 300 },
                //        { name: 'Group C', value: 300 },
                //        { name: 'Group D', value: 200 },
                //        { name: 'Group E', value: 278 },
                //        { name: 'Group F', value: 189 },
                //    ]}/></div>
                // }



            } catch(e) {
                console.warn(e);
                return null
            }
        } else {
            return null
        }
    }

    const translateValueToRisk = (value) => {
        if (typeof value !== "number") {
            return null
        } else if (value <= 0) {
            return 0
        } else if (value <= 2) {
            return 1
        } else if (value <= 5) {
            return 2
        } else if (value <= 15) {
            return 3
        } else {
            return 4
        }
    }

    const riskRibbon = (stateData) => {
        const num = translateValueToRisk(valueFunction(stateData));
        return num
            ? <RiskRibbon ratingBy5={num} />
            : null;
    }

    const valueFunction = (stateData) => stateData ? stateData[customerIdToUse] ? stateData[customerIdToUse].active_services_list.filter(service => bbIsServiceHighRisk(service)).length : null : null;


    return (
        <DataTile
            color = {colorFunction()}
            colorBgFunction={colorFunction}
            subTitle="High-Risk Services"
            tipText={`Services that have historically demonstrated especially high impact when exploited.  Some attackers specifically look for these services above all others.  Includes RDP, SSH, netBios, SMB, telnet, FTP, and others.`}
            icon={<div
                className={"animated fadeIn animation-duration-7"}
                style={{ marginTop: -40, marginBottom: -15 }}
            ><CustomActiveShapePieChart
                data = {[]}
                riskBy5={-1}
                loading
            /></div>}
            iconFunction = {showPieWith}
            iconClasses={" "}
            stateName="customer"
            stateElement="metaTargets"
            // useDeepDataStore
            // dontFetch
            // forceLoadingState = {true}
            // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse] : null : null}
            stateLoaderName="loadingTargets"
            stateLoaderError="loadingTargetsError"
            stateFetchAction={fetchTargets(
                {
                    customerId: customerIdToUse
                }
            )}
            preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            ribbonFunction={riskRibbon}
            requiresModule={"monitor"}
        />
    )

}

export default Tile;